import React from 'react';
import { Box, Typography, useTheme } from '@material-ui/core';
import { lighten, Theme } from '@material-ui/core/styles';
import { getIntensityColor } from '../../utils';

export const DateLabel = ({ label }: { label: string }) => {
    const theme = useTheme<{
        palette: Theme['palette'] & { background: { dark: string } };
    }>();

    const intensityColor = getIntensityColor(theme.palette.type);

    return (
        <Box
            px={2}
            py={1}
            borderRadius={5}
            style={{
                background: lighten(theme.palette.primary.main, intensityColor),
            }}
        >
            <Typography
                variant="caption"
                style={{
                    color: theme.palette.getContrastText(
                        lighten(theme.palette.primary.main, intensityColor)
                    ),
                }}
            >
                {label}
            </Typography>
        </Box>
    );
};
